import { connect } from 'react-redux';

import CustomersListItem from '../components/CustomersListItem';
import { getById } from '../../barbers/selector';
import { fullName } from '../../../common/helpers/users';
import { t } from '../../../../modules/infra/i18n';

const CustomersListItemContainer = connect(
  (state, ownProps) => ({
    barber: ownProps.showBarber && ownProps.customer.barberId
      ? `${t('appointment:waiting_list.barber_prefix')}: ${fullName(getById(state, ownProps.customer.barberId))}`
      : '',
  })
)(CustomersListItem);

export default CustomersListItemContainer;
